'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'party-horn';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e31b';
var svgPathData = 'M64 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM64 0a32 32 0 1 1 0 64A32 32 0 1 1 64 0zm64.9 460.2L51.8 383.1 18.5 475.9l17.7 17.7 92.8-33.3zm16.7-6l77.5-27.8L85.6 288.9 57.8 366.4l87.8 87.8zm93.7-33.6l75.6-27.1L118.5 197.2 91.4 272.8c.8 .4 1.6 .9 2.3 1.6l144 144c.7 .7 1.2 1.4 1.6 2.3zM32 512L0 480 106 184.7l6-16.7 12.5 12.5 207 207L344 400l-16.6 6L32 512zM496 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 304a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM256 8c0 38.7-21.3 76.4-41.6 103.8c-10.2 13.8-20.5 25.3-28.1 33.4c-3.8 4-7 7.2-9.3 9.4c-1.1 1.1-2 1.9-2.6 2.5l-.7 .7-.2 .2c0 0 0 0-.1 0c0 0 0 0 0 0s0 0 0 0L168 152l5.4 5.9-5.9 5.4-10.7-11.9 5.9-5.3s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.1-.1 .6-.6c.6-.5 1.4-1.3 2.4-2.3c2.1-2 5.2-5.1 8.8-8.9c7.3-7.7 17.1-18.7 26.9-31.9C221.3 75.6 240 41.3 240 8l0-8 16 0 0 8zM366.6 348.5s0 0 0 0s0 0 0 0s0 0 0 0l-4.5 6.6-13.3-9 4.5-6.6L360 344c-6.6-4.5-6.6-4.5-6.6-4.5s0 0 0 0s0 0 0 0c0 0 0 0 0-.1l.1-.2 .5-.8c.5-.6 1.1-1.6 2-2.7c1.7-2.3 4.3-5.6 7.7-9.5c6.7-7.8 16.6-18.1 29.4-28.5C418.8 277.1 456.5 256 504 256l8 0 0 16-8 0c-42.5 0-76.8 18.9-100.7 38.2c-11.9 9.6-21.1 19.3-27.4 26.5c-3.1 3.6-5.5 6.6-7 8.7c-.8 1-1.4 1.8-1.7 2.4l-.4 .6-.1 .1s0 0 0 0zM492.5 28.8c-12.6 11.1-28.9 17-45.6 16.5c-25.2-.7-47 17.4-51 42.4L389 131.7c-5.9 37.4-36.8 65.8-74.6 68.6c-13.8 1-27 6.4-37.5 15.3l-7.7 6.6-6.1 5.2-10.3-12.2 6.1-5.2 7.7-6.5c13.2-11.1 29.5-17.8 46.7-19.1c30.4-2.2 55.2-25.1 59.9-55.1l6.9-43.9c5.2-32.9 33.9-56.8 67.2-55.9c12.7 .3 25.1-4.1 34.6-12.5L498.7 2l10.6 12L492.5 28.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPartyHorn = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;